<template>
  <div class="container-fluid py-4">
    <div class="card shadow-sm p-4">
      <div class="row align-items-center mb-3">
        <div class="col-12 col-md-6">
          <h5 class="mb-0">
            <i class="fa fa-file-invoice me-2 text-success"></i>
            Nuevo Documento
          </h5>
          <small class="text-muted">{{ factura.header.invoice_type }} #{{ facturaTempNumber }}</small>
        </div>
        <div class="col-12 col-md-2 text-md-end mt-3 mt-md-0">
          <argon-button class="btn btn-success w-100" @click="goBack">
            <i class="fa fa-arrow-left me-1"></i> Volver
          </argon-button>
        </div>
        <div class="col-12 col-md-2 text-md-end mt-3 mt-md-0">
          <argon-button class="btn btn-success w-100 " @click="guardarFactura" :disabled="isSaved || factura.lines.length === 0">
            <i class="fa fa-save me-1"></i> {{ isSaving ? 'Guardando...' : 'Guardar' }}
          </argon-button>
        </div>
        <div class="col-12 col-md-2 text-md-end mt-3 mt-md-0">
          <argon-button class="btn btn-success w-100 " @click="printPDF" :disabled="factura.lines.length === 0">
            <i class="fa fa-print me-1"></i> Imprimir
          </argon-button>
        </div>
      </div>
      <div class="card bg-light border-0 mb-4 p-3">
        <div class="row g-3 align-items-end">
          <div class="col-md-6">
            <label class="form-label mb-1">Cliente</label>
            <ArgonLookup
                :options="clientes"
                v-model="clienteSeleccionado"
                display-key="display_name"
                track-by="id"
                placeholder="Escriba nombre o DUI del cliente..."
            >
                <template #option="{ option }">
                    <div class="d-flex justify-content-between align-items-center w-100">
                        <span>
                            <span class="font-weight-bold">{{ option.name }}</span>
                        </span>
                        <span class="text-sm text-muted">
                            DUI: {{ option.nit }}
                        </span>
                    </div>
                </template>

            </ArgonLookup>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1">Fecha</label>
            <input type="date" class="form-control" v-model="factura.fecha" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-sm">Tipo de documento</label>
            <select v-model="factura.header.invoice_type" class="form-select" :disabled="customerDisabled">
              <option value="FACTURA">Factura</option>
              <option value="CREDITO_FISCAL">Factura Crédito Fiscal</option>
              <option value="TICKET">Ticket</option>
            </select>
          </div>
        </div>
        <div class="row g-3 align-items-end mt-2">
            <div class="col-md-3">
                <label class="form-label mb-1">Condición de Pago</label>
                <select v-model.number="factura.header.payment_condition" class="form-select">
                    <option :value="1">1 - Contado</option>
                    <option :value="2">2 - Crédito</option>
                </select>
            </div>

            <div class="col-md-3" v-if="factura.header.payment_condition === 1">
                <label class="form-label mb-1">Medio de Pago</label>
                <select v-model="factura.header.payment_type" class="form-select" placeholder="Seleccione">
                  <option v-for="option in paymentOptions" :value="option.value" :key="option.value">
                      {{ option.text }}
                  </option>
                </select>
            </div>


                <div class="col-md-3" v-if="factura.header.payment_condition === 2">
                    <label class="form-label mb-1">Término</label>
                    <input type="number" min="1" class="form-control" v-model.number="factura.header.term" />
                </div>
                <div class="col-md-3" v-if="factura.header.payment_condition === 2">
                    <label class="form-label mb-1">Plazo</label>
                    <select v-model="factura.header.term_type" class="form-select">
                        <option value="01">01 - Días</option>
                        <option value="02">02 - Meses</option>
                        <option value="03">03 - Años</option>
                    </select>
                </div>
                <div class="col-md-3" v-if="factura.header.payment_condition === 2">
                    <label class="form-label mb-1">Vencimiento</label>
                    <input type="date" class="form-control" :value="factura.header.due_date" disabled />
                </div>
        </div>
      </div>

      <div class="card border mb-4 p-3">
        <div class="row g-3 align-items-end">
          <div class="col-md-6">
            <label class="form-label mb-1">Producto</label>
            <ArgonLookup
                :options="productos"
                v-model="productoSeleccionado"
                display-key="display_name"
                placeholder="Escriba SKU o nombre del producto..."
            >
                <template #option="{ option }">
                    <div class="d-flex justify-content-between align-items-center w-100">
                        <span>
                            <span class="font-weight-bold">{{ option.sku }}</span> -
                            {{ option.nombre }}
                        </span>
                        <span class="text-sm font-weight-bold text-success">
                            ${{ option.precio_venta.toFixed(3) }}
                        </span>
                    </div>
                </template>

            </ArgonLookup>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1">Cantidad</label>
            <input type="number" min="1" class="form-control" v-model.number="cantidad" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1">Precio</label>
            <input type="number" step="0.001" class="form-control" v-model.number="precio" min="0"/>
          </div>
          <!-- <div class="col-md-2">
            <label class="form-label mb-1">Descuento</label>
            <input type="number" step="0.01" class="form-control" v-model.number="descuento" />
          </div>-->
          <div class="col-md-2 text-md-end mt-3 mt-md-0">
            <argon-button class="btn btn-success w-100 " @click="agregarProducto" :disabled="isSaved || clienteSeleccionado === null || allowAdd">
              <i class="fa fa-plus me-1"></i> Agregar
            </argon-button>
          </div>
        </div>
        <div class="row g-3 align-items-end">
          <div class="col-md-12">
<!--             <label class="form-label mb-1">Descripción</label>
 -->            <argon-textarea :hassError="allowAdd" id="productDescription" type="text" v-model="productDescription" rows="2" placeholder="Agregar descripción adicional si es necesario..." :max-length="maxLineLength" @input="valLineLenght"/>
                <small>{{ (currentLineLength) }} de {{ maxLineLength }}</small>
          </div>

        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Producto</th>
              <th class="text-center">Cant.</th>
              <th class="text-end">Precio</th>
              <th class="text-end">Descuento</th> <th class="text-end">Impuesto</th>
              <th class="text-end">Total Línea</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in factura.lines" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.nombre }}</td>
                <td class="text-center">{{ item.cantidad }}</td>
                <td class="text-end">${{ formatCurrency(Number(item.precio).toFixed(3)) }}</td>
                <td class="text-end text-danger">${{ formatCurrency(item.discount.toFixed(3)) }}</td> <td class="text-end">${{ formatCurrency(item.tax_amount.toFixed(3)) }}</td> <td class="text-end">${{ item.line_total.toFixed(3) }}</td> <td class="text-end">
                    <button class="btn btn-sm btn-danger" @click="eliminarProducto(index)">
                        <i class="fa fa-trash"></i>
                    </button>
                </td>
            </tr>
            <tr v-if="factura.lines.length === 0">
                <td colspan="8" class="text-center text-muted">No hay productos agregados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <div class="text-end">
            <p class="mb-1"><strong>Subtotal Bruto:</strong> ${{ formatCurrency(subtotalBruto) }}</p>
            <p class="mb-1 text-danger"><strong>Descuento Total:</strong> ${{ formatCurrency(totalDescuento*-1) }}</p>
            <p class="mb-1"><strong>Subtotal Neto (Base Imp.):</strong> ${{ formatCurrency(subtotalNeto) }}</p>
            <p class="mb-1"><strong>IVA ({{tax_symbol}}%):</strong> ${{ formatCurrency(iva) }}</p>
            <p class="mb-1 text-danger"><strong>Retención:</strong> ${{ formatCurrency(retention*-1) }}</p>
            <h5 class="mb-0"><strong>Total Final:</strong> ${{ formatCurrency(total) }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useInvoicePrinter } from "@/composables/useInvoicePrinterPOS";
import { useDTEFiscal } from "@/composables/useDTEFiscal";
import { useCompanyConfig } from '@/composables/useCompanyConfig';
import { currentLocalDate } from '@/composables/useUtils';
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonLookup from "@/components/ArgonLookup.vue";
import axios from 'axios';
const companyId = localStorage.getItem('companyId');

export default {
  name: "CreateInvoices",
  components: { ArgonButton,ArgonLookup,ArgonTextarea },
  setup(){
        const { companyConfig,isLoadingCiaConfig, fetchCompanyConfig } = useCompanyConfig();
        // Cargar la configuración cada vez que el componente se monte/cargue
        fetchCompanyConfig();
        return { companyConfig ,isLoadingCiaConfig};
  },
  data() {
    return {
      maxLineLength:1000,
      currentLineLength:0,
      currentProductLength:0,
      customerDisabled:false,
      isSaving:false,
      isSaved:false,
      allowAdd:false,
      facturaTempNumber: "0000",
      clientes: [],
      clientsBulk:[],
      productos: [],
      factura: {
        client_id: "",
        fecha: currentLocalDate(),
        lines: [],
        full_number:"",
        tax_rate:0,
        mapClientToHeader:null,
        header:{
          emitter_nit: "12345678-9",
          emitter_name: "Mi Empresa POS",
          invoice_type:"FACTURA",
          currency: "USD",
          state: "EMITTED",
          full_number: null,
          date_issued: null,
          subtotal: 0,
          total_taxes: 0,
          retention_amount:0,
          total: 0,
          dte_trace_code:'',
          dte_stamp_code:'',
          dte_url_code:'',
          client_address: null,
          client_nrc: null,
          client_document_type: '36',
          client_department_code: null,
          client_municipality_code: null,
          client_department: null,
          client_municipality: null,
          client_activity_code: '99999',
          client_activity_desc: 'Venta al consumidor',
          client_email: null,
          client_phone:null,
          excent:null,
          client_type:null,
          dte_type:null,
          payment_condition: 1,
          payment_type: "01",
          term_type: null,
          term: null,
          due_date: null,
        },

      },
      productoSeleccionado: null,
      clienteSeleccionado:null,
      cantidad: 1,
      precio: 0,
      descuento: 0,
      tax_rate:0,
      retention_amount:100,
      retention_rate:0.10,
      contributor_rate:0.01,
      currentServicio:null,
      paymentOptions: [
        { value: '01', text: '01 - Billetes y monedas' },
        { value: '02', text: '02 - Tarjeta Débito' },
        { value: '03', text: '03 - Tarjeta Crédito' },
        { value: '04', text: '04 - Cheque' },
        { value: '05', text: '05 - Transferencia-Depósito Bancario' },
        { value: '08', text: '08 - Dinero electrónico' },
        { value: '09', text: '09 - Monedero electrónico' },
        { value: '11', text: '11 - Bitcoin' },
        { value: '12', text: '12 - Otras Criptomonedas' },
        { value: '13', text: '13 - Cuentas por pagar del receptor' },
        { value: '14', text: '14 - Giro bancario' },
        { value: '99', text: '99 - Otros (se debe indicar el medio de pago)' },
    ],
    };
  },
  watch: {
    'factura.fecha': 'calculateDueDate',
    'factura.header.term': 'calculateDueDate',
    'factura.header.term_type': 'calculateDueDate',
    'factura.header.payment_condition'(newVal) {
        if (newVal === 1) {
            // Contado: Limpiar términos
            this.factura.header.term = 0;
            this.factura.header.due_date = null;
            this.factura.header.payment_type = '01'; // Asignar un tipo de pago por defecto
        } else {
            // Crédito: Forzar re-cálculo
            this.factura.header.payment_type = null; // Limpiar tipo de pago
            this.calculateDueDate();
        }
    },
    payment_condition(newValue){
      if(newValue===1){
        this.factura.header.term=null;
        this.factura.header.term_type=null;
        this.factura.header.term=null;
      }else{
        this.factura.header.term=null;
        this.factura.header.term_type=null;
        this.factura.header.term=null;
      }
    },
    precio(newValue) {
        // Aseguramos que el precio nunca sea negativo.
        if (newValue < 0) {
            this.precio = 0;
        }
    },
    companyConfig(newVal){
      this.tax_rate=newVal.default_tax_rate;
      this.factura.header.emitter_nit=newVal.dte_client_id;
      this.contributor_rate= newVal.default_major_contributors_rate;
      this.retention_rate= newVal.default_retention_rate;
      this.retention_amount=newVal.retention_amount;
      console.log(this.factura.header.emitter_nit);
      this.tax_symbol= (newVal.default_tax_rate*100).toFixed(0);
    },
    clienteSeleccionado(newClient) {
      //console.log(newClient);
      if (!newClient) {
          this.factura.client_id = "";
          this.factura.header.client_name = 'Consumidor Final';
          this.factura.header.client_nit = '0000000000'; // CF por defecto
          this.mapClientToHeader({ type: 'NATURAL' });
          return;
      }
      const fullClientData = this.clientsBulk.find(c => c.id === newClient.id);
      this.factura.header.client_type=newClient.type;
      const clientType = newClient.type||null;
      // 1. Validar y asignar el dte_type basado en el tipo de cliente
      let dteCode = '01'; // Valor por defecto: Consumidor Final
      console.log(clientType);
      if (clientType) {
          switch (clientType) {
              case 'JURIDICA':
                  dteCode = '03'; // Crédito Fiscal
                  this.customerDisabled=true;
                  this.factura.header.invoice_type='CREDITO_FISCAL';
                  break;
              case 'EXCLUIDO':
                  dteCode = '14'; // Factura de Sujeto Excluido (FSEE)
                  this.customerDisabled=true;
                  this.factura.header.invoice_type='FACTURA';
                  break;
              case 'NATURAL':
                  if(!newClient.nrc){
                    this.customerDisabled=true;
                    this.factura.header.invoice_type='FACTURA';
                  }else{
                    this.customerDisabled=false;
                  }
                  break;
              default:
                  this.customerDisabled=false;
                  this.factura.header.invoice_type='FACTURA';
                  dteCode = '01'; // Consumidor Final
                  break;
          }
      }
      this.factura.header.dte_type = dteCode;
      console.log(dteCode);
      let clientToMap;
      if (fullClientData) {
          clientToMap = {
              ...fullClientData,
              type: newClient.type || fullClientData.type,
              // Sobrescribimos con los campos que pueden ser más recientes del lookup
              nit: newClient.nit || fullClientData.nit,
              name: newClient.name || fullClientData.name,
          };
      } else {
          // Si no se encuentra en el bulk (raro), usamos la data parcial del lookup
          console.warn(`Datos completos del cliente ID ${newClient.id} no encontrados en clientsBulk.`);
          clientToMap = newClient;
      }

      this.factura.client_id = clientToMap.id;
      this.mapClientToHeader(clientToMap);
    },
    productoSeleccionado(newVal) {
      // auto llenar precio al seleccionar producto
      if (newVal) {
        this.precio = Number(newVal.precio_venta) || 0;
        this.currentProductLength=this.productoSeleccionado.nombre.length+3;
        //this.currentLineLength=this.currentLineLength-this.currentProductLength;
      } else {
        this.precio = 0;
      }
    }
  },
  computed: {

    totalDescuento() {
      // Suma de descuentos por línea
      return this.factura.lines.reduce((sum, i) => sum + Number(i.discount), 0);
    },
    subtotalBruto() {
      // Suma de (Precio * Cantidad) sin descuentos ni impuestos
      return this.factura.lines.reduce((sum, i) => sum + (Number(i.cantidad) * Number(i.precio)), 0);
    },
    subtotalNeto() {
      // Suma de (Precio * Cantidad - Descuento) -> Base Imponible
      return this.subtotalBruto - this.totalDescuento;
    },
    iva() {
      // Suma total de los montos de IVA calculados por línea
      return this.factura.lines.reduce((sum, i) => sum + Number(i.tax_amount), 0);
    },
    retention(){
      return this.factura.lines.reduce((sum, i) => sum + Number(i.retention_amount), 0);
    },
    total() {
      // Total Final = Subtotal Neto + IVA Total
      if(this.factura.header.client_type=='NATURAL'){
         return this.factura.lines.reduce((sum, i) => sum + Number(i.line_total), 0);
      }else if(this.factura.header.client_type=='EXCLUIDO'){
        return this.factura.lines.reduce((sum, i) => sum + Number(i.line_total), 0);
      }
      else{
        return Number(this.subtotalNeto) + Number(this.iva)-Number(this.retention);
      }
    },
  },
  methods: {
    calculateDueDate() {
        const term = this.factura.header.term || 0;
        const termType = this.factura.header.term_type;
        const date = new Date(this.factura.fecha); // Usamos la fecha de emisión de la factura

        if (this.factura.header.payment_condition !== 2 || term === 0) {
            this.factura.header.due_date = null;
            return;
        }

        // Convertir el término a número entero
        const termValue = parseInt(term);

        // Añadir el término a la fecha
        if (termType === '01') { // Días
            date.setDate(date.getDate() + termValue);
        } else if (termType === '02') { // Meses
            date.setMonth(date.getMonth() + termValue);
        } else if (termType === '03') { // Años
            date.setFullYear(date.getFullYear() + termValue);
        }

        // Formatear la fecha a YYYY-MM-DD (formato requerido por el input type="date")
        this.factura.header.due_date = date.toISOString().split("T")[0];
    },
    async fetchCustomers(config){
      let self=this;
      axios.get(this.$store.state.apiURL+'clients?company='+companyId,config)
      .then((result)=>{
        this.clientes=result.data.map(item => ({
          id: item.id,
          name: item.full_name || item.name,
          nit: item.nit || 'CF',
          type: item.type || 'NATURAL',
          nrc:item.nrc ||null,
          destionation:item.destination || null,
          // Campo combinado para la búsqueda y el input
          display_name: `${item.full_name || item.name} - NIT: ${item.nit || 'CF'}`
        }));
        this.clientsBulk= result.data;
        //console.log(this.clientsBulk);
      })
      .catch(error => {
        console.log(error)
        self.$swal({
            title: 'Sesión',
            text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
            type: 'warning',
            icon:'warning',
            showCancelButton: false,
            confirmButtonColor:'#bf4f51',
            showCloseButton: true,
            showLoaderOnConfirm: false
        }).then(function(){
            localStorage.removeItem('user');
            localStorage.removeItem('accessToken');
            self.$router.push('/signin');
        });
      });
    },
    async fetchProducts(config){
      let self=this;
      axios.get(this.$store.state.apiURL+'products?state=1&company='+companyId,config)
      .then((result)=>{
        this.productos= result.data.map(item => {
                    const precio = parseFloat(item.sale_price) || 0;
                    const sku = item.sku || `P-${item.id}`;

                    return {
                        id: item.id,
                        nombre: item.name,
                        precio_venta: precio,
                        sku: sku,
                        // Creamos un campo combinado que ArgonLookup usará por defecto
                        display_name: `${sku} - ${item.name}`
                    };
              });

        const defaultProduct = this.productos.find(p =>
            p.nombre && p.nombre.toUpperCase().trim() === "BIENES Y SERVICIOS"
        );

        if (defaultProduct) {
            // Usamos el spread operator {...} para crear una nueva referencia
            // y asegurar que el buscador lo detecte
            this.productoSeleccionado = { ...defaultProduct };
        }
      })
      .catch(error => {
        console.log(error)
        self.$swal({
            title: 'Sesión',
            text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
            type: 'warning',
            icon:'warning',
            showCancelButton: false,
            confirmButtonColor:'#bf4f51',
            showCloseButton: true,
            showLoaderOnConfirm: false
        }).then(function(){
            localStorage.removeItem('user');
            localStorage.removeItem('accessToken');
            self.$router.push('/signin');
        });
      });
    },

    agregarProducto() {
      if (!this.productoSeleccionado) return alert("Seleccione un producto");
      if (!this.cantidad || this.cantidad <= 0) return alert("Ingrese una cantidad válida");
      if (this.descuento < 0) return alert("El descuento no puede ser negativo");

      // --- 1. Definiciones Iniciales ---
      const taxRate = parseFloat(this.tax_rate);
      const RETENTION_RATE_EXCLUDED = this.retention_rate;
      const RETENCION_RATE_CONTRIBUTOR = this.contributor_rate;
      let retentionAmount = 0;

      // Capturamos el precio que viene del input (ej: 7.00)
      const precioIngresado = Number(this.precio || this.productoSeleccionado.precio_venta);
      const cantidadNum = Number(this.cantidad);
      const descuentoMonto = Number(this.descuento) || 0;

      // Variables de cliente
      const clientType = this.factura.header.client_type;
      const isExcluded = clientType === 'EXCLUIDO';
      const isCCF = clientType === 'JURIDICA'; // DTE 03
      const isCF = clientType === 'NATURAL';  // DTE 01

      // --- 2. Determinación de Precios y Bases ---
      let precioUnitarioDTE = 0;
      let montoGravadoLinea = 0;
      let precioBaseSinIVA = 0;   // Lo calcularemos según el caso

      if (isExcluded) {
          // CASO 1: EXENTO - El precio ingresado no tiene IVA
          precioBaseSinIVA = precioIngresado;
          precioUnitarioDTE = precioBaseSinIVA;
          montoGravadoLinea = (precioUnitarioDTE * cantidadNum) - descuentoMonto;

      } else if (isCF) {
          // 🛑 CASO 2: CONSUMIDOR FINAL (Precio incluye IVA) 🛑
          // Si ingresas 7, el precioUnitarioDTE es 7.
          precioUnitarioDTE = precioIngresado;

          // Calculamos la base real para los impuestos: Base = 7 / 1.13
          precioBaseSinIVA = precioUnitarioDTE / (1 + taxRate);

          // Venta Gravada Neta (Base Imponible exigida por DGII)
          // Se calcula restando el descuento a la base neta
          const subtotalBrutoConIVA = cantidadNum * precioUnitarioDTE;
          montoGravadoLinea = (subtotalBrutoConIVA - descuentoMonto) / (1 + taxRate);

          // Retención: Se calcula sobre el montoGravadoLinea (Base Neta)
          if (this.factura.header.retention_category > 0) {
              retentionAmount = montoGravadoLinea * RETENCION_RATE_CONTRIBUTOR;
          }

      } else if (isCCF) {
          // CASO 3: CRÉDITO FISCAL (Precio NO incluye IVA)
          precioBaseSinIVA = precioIngresado;
          precioUnitarioDTE = precioBaseSinIVA;
          montoGravadoLinea = (precioUnitarioDTE * cantidadNum) - descuentoMonto;

          if (this.factura.header.retention_category > 0) {
              if (montoGravadoLinea >= this.retention_amount) {
                  retentionAmount = montoGravadoLinea * RETENCION_RATE_CONTRIBUTOR;
              }
          }
      }

      // --- 3. Cálculo de Totales y Desglose ---
      const subtotalBruto = cantidadNum * precioUnitarioDTE;
      let ivaMonto = 0;

      if (!isExcluded) {
          // El IVA siempre es el 13% de la BASE NETA (montoGravadoLinea)
          ivaMonto = montoGravadoLinea * taxRate;
      }

      const subtotalNeto = montoGravadoLinea;

      // Total Final de la Línea (Lo que el cliente paga)
      // Para CF, si ingresaste 7, el totalFinal debe ser 7 (menos retenciones si aplica)
      let totalFinal = (montoGravadoLinea + ivaMonto) - retentionAmount;

      if (isExcluded) {
          retentionAmount = montoGravadoLinea * RETENTION_RATE_EXCLUDED;
          totalFinal = montoGravadoLinea - retentionAmount;
      }

      const partes = [this.productoSeleccionado.nombre];


      if (this.currentServicio != null) {
          partes.push(this.currentServicio);
      }

      if (this.productDescription) {
          partes.push(this.productDescription);
      }

      // 2. Los unimos todos con el separador " - "
      const nombreFinal = partes.join(' - ');

      const item = {
          id: this.productoSeleccionado.id,
          nombre: nombreFinal,
          cantidad: cantidadNum,
          quantity: cantidadNum,
          precio: Number(precioUnitarioDTE).toFixed(3),
          unit_price: Number(precioUnitarioDTE).toFixed(3),
          discount: descuentoMonto,
          tax_rate: taxRate,
          tax_amount: Number(ivaMonto.toFixed(3)),
          retention_amount: Number(retentionAmount.toFixed(3)),
          sub_total_brut: Number(subtotalBruto.toFixed(3)),
          sub_total: Number(subtotalNeto.toFixed(3)),
          subtotal_neto: Number(subtotalNeto.toFixed(3)),
          line_total: Number(totalFinal.toFixed(3))
      };

      this.factura.lines.push(item);

      // Limpiar inputs
      this.productoSeleccionado = null;
      this.cantidad = 1;
      this.precio = 0;
      this.descuento = 0;
      this.productDescription = null;
      this.allowAdd = false;

      const defaultProduct = this.productos.find(p =>
          p.nombre && p.nombre.toUpperCase().trim() === "BIENES Y SERVICIOS"
      );

      if (defaultProduct) {
          // Usamos el spread operator {...} para crear una nueva referencia
          // y asegurar que el buscador lo detecte
          this.productoSeleccionado = { ...defaultProduct };
      }
    },
    eliminarProducto(index) {
      this.factura.lines.splice(index, 1);
    },
    mapClientToHeader(client) {
      // Utiliza el operador de fusión de nulos (??) para los valores por defecto
      this.factura.header.client_name = client?.name || 'Consumidor Final';
      this.factura.header.client_nit = client?.nit || '0000000000';
      this.factura.header.client_address = client?.fiscal_address || client?.commercial_address || 'Sin dirección';
      this.factura.header.client_nrc = client?.nrc || null;
      this.factura.header.client_document_type = client?.document_type || '36'; // 36=Consumidor Final
      this.factura.header.client_department = client?.department || null;
      this.factura.header.client_department_code = client?.department_code || null;
      this.factura.header.client_municipality = client?.municipality || null;
      this.factura.header.client_municipality_code = client?.municipality_code || null;
      this.factura.header.client_activity_code = client?.activity_code || '99999'; // 99999=Varios/CF
      this.factura.header.client_activity_desc = client?.activity_desc || 'Venta al consumidor';
      this.factura.header.client_email = client?.email || null;
      this.factura.header.client_phone=client?.phone || null;
      this.factura.header.excent=client?.excent || null;
      this.factura.header.retention_category=client?.retention_category||null;
      this.currentServicio=client?.destination||null;
    },
    async getNextSerial() {
      const dteType = this.factura.header.dte_type || '01';
      const isExcluded = this.factura.header.excent === 1;

      // Convertir el string DTE (01, 03, 14) al número entero esperado por la tabla `serial`.
      let serialType = 0;

      if (dteType === '01' || dteType === '03' || dteType === '14') {
          serialType = parseInt(dteType, 10);
          console.log(serialType);
      } else {
          // Fallback o manejo de error si el tipo DTE no es reconocido.
          this.$swal('Error de DTE', 'Tipo de documento fiscal no reconocido.', 'error');
          throw new Error("Invalid DTE Type");
      }

      const token = localStorage.getItem("accessToken");
      const apiURL = this.$store.state.apiURL;

      if (!token) {
          this.$swal('Error de Sesión', 'Acceso denegado. Reinicie sesión.', 'error');
          throw new Error("No token");
      }

      try {
          // 🛑 DATOS ENVIADOS AL BACKEND: Usamos el serialType mapeado 🛑
          const payload = {
              type: serialType, // ⬅️ Enviamos el número entero: 1, 3 o 14
              company: this.companyConfig.id,
              excent: isExcluded ? 1 : 0 // Enviamos la bandera de exención si el backend la necesita
          };

          const response = await axios.post(
              apiURL + 'serial/reserve_next',
              payload,
              { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
          );

          console.log('Número de Control Reservado:', response.data.full_number);
          return response.data;

      } catch (error) {
          console.error("Error al obtener y reservar el serial:", error.response || error);

          const errorText = error.response?.data?.error || 'No se pudo reservar el número consecutivo. Intente de nuevo.';
          this.$swal('Error de Serial', errorText, 'error');
          throw new Error("Serial Reservation Failed");
      }
    },
    async guardarFactura() {
      if (this.isSaving) return;
      console.log(this.factura);
      if (!this.factura.client_id || this.factura.lines.length === 0) {
          this.$swal('Error', 'Debe seleccionar un cliente y agregar al menos un producto.', 'error');
          return;
      }

      this.isSaving = true;
      const token = localStorage.getItem("accessToken");
      const apiURL = this.$store.state.apiURL;
      const user = JSON.parse(localStorage.getItem('userId'));
      const cliente = this.clienteSeleccionado;
      const fullNumberCurrent= await this.getNextSerial();
      const sendDTE = (this.factura.header.invoice_type === 'TICKET') ? 0 : this.companyConfig.send_dte;
      this.facturaTempNumber= fullNumberCurrent.full_number;
      console.log(fullNumberCurrent);
      // --- A. Preparar Header para la BD ---
      const headerData = {
          ...this.factura.header,
          emitter_name:this.companyConfig.emitter_name,
          dte_env:this.companyConfig.dte_env,
          emitter_nit:this.factura.header.emitter_nit,
          client_id: this.factura.client_id,
          client_nit: cliente ? cliente.nit : 'CF',
          client_name: cliente ? cliente.name : 'Consumidor Final',
          date_issued: this.factura.fecha + ' ' + new Date().toTimeString().split(' ')[0],
          sub_total_brut:this.subtotalBruto.toFixed(3),
          subtotal: this.subtotalNeto.toFixed(3), // Base imponible
          total_taxes: this.iva.toFixed(3), // Monto total de impuestos
          retention_amount:this.retention.toFixed(3),
          total_discount: this.totalDescuento.toFixed(3), // Monto total de descuentos
          total: this.total.toFixed(3), // Total final
          company:this.companyConfig.id,
          full_number: fullNumberCurrent.full_number,
          series: fullNumberCurrent.series,
          number:fullNumberCurrent.number,
          created_by: user ? user : null,
          payment_condition:this.factura.header.payment_condition,
          payment_type:this.factura.header.payment_type,
          due_date:this.factura.header.due_date,
          term_type:this.factura.header.term_type,
          term:this.factura.header.term
      };

      // --- B. Mapear Líneas para la BD ---
      const linesData = this.factura.lines.map(line => ({
          product_id: line.id,
          description: line.nombre,
          quantity: Number(line.cantidad).toFixed(4),
          unit_price: Number(line.precio).toFixed(4),
          discount: Number(line.discount).toFixed(4),
          tax_rate: Number(line.tax_amount).toFixed(4), // 13.00
          sub_total:Number(line.sub_total).toFixed(4),
          sub_total_brut:Number(line.sub_total_brut).toFixed(4),
          line_total: Number(line.line_total).toFixed(4), // Total final de la línea (Base - Desc + IVA)
          warehouse_id: 1,
          allocated: 1
      }));
      console.log(sendDTE);
      const payload = { header: headerData, lines: linesData , emit_dte:sendDTE, company:this.companyConfig.id};
      const config = { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } };
      console.log(payload);
      // --- C. Enviar al Backend (Transacción Atómica) ---
      try {
          const response = await axios.post(apiURL + 'invoices/transaction', payload, config);

          this.$swal({
              title: '¡Éxito!',
              text: `Factura ${response.data.full_number} procesada.`,
              icon: 'success',
              confirmButtonColor: '#0b9257'
          }).then(() => {
              this.factura.header.dte_trace_code= response.data.dte_result.traceability_code;
              this.factura.header.dte_stamp_code= response.data.dte_result.stamp_code;
              this.factura.header.dte_url_code= response.data.dte_result.url_code;

              this.isSaved=true;
              this.printPDF();
          });

      } catch (error) {
          console.error("Error al procesar factura:", error.response || error);
          this.$swal({
              title: 'Error de Transacción',
              text: error.response?.data?.error || 'Ocurrió un error desconocido. La transacción fue revertida (Rollback).',
              icon: 'error'
          });
      } finally {
          this.isSaving = false;
      }
    },
    async printPDF() {
      if (this.factura.lines.length === 0) {
          alert('Debe agregar productos para imprimir.');
          return;
      }
      // Creamos un objeto que contenga todos los datos necesarios (factura, subtotalBruto)
      const facturaData = {
          ...this.factura,
          header: {
              ...this.factura.header,
              full_number:this.facturaTempNumber,
              subtotal:this.subtotalNeto,
              total_discount:this.totalDescuento,
              total_taxes:this.iva,
              total:this.total,
              sub_total_brut: this.subtotalBruto, // Agregamos el bruto para el composable
              dte_type:this.factura.header.dte_type,
              date_issued:this.factura.fecha + ' ' + new Date().toTimeString().split(' ')[0],
              retention_amount:this.retention.toFixed(3)
          }
      };
      // LLAMADA CENTRALIZADA: isReimpresion = false
      let formatToUse = this.companyConfig.invoice_default_format
      if(facturaData.header.invoice_type=='TICKET'){
          useInvoicePrinter(facturaData,this.companyConfig, true);
      }else{
        if (formatToUse == 3 || (formatToUse != 1 && formatToUse != 2)) {
            const selection = await this.askForInvoiceFormat();
            formatToUse = selection;
        }
        if (formatToUse == 1) {
            // Formato 1: Ticket (POS)
            useInvoicePrinter(facturaData, this.companyConfig, false);
        } else if (formatToUse == 2) {
            // Formato 2: Legible (Carta / DTE Fiscal)
            useDTEFiscal(facturaData, this.companyConfig, false);
        } else {
            // Se selecciona 0 (Cancelación) o un valor no válido
            self.$swal('Impresión Cancelada', 'No se seleccionó un formato válido.', 'info');
        }
      }
    },
    async askForInvoiceFormat() {
      const result = await this.$swal({
          title: 'Seleccione Formato de Impresión',
          text: '¿Qué formato desea utilizar para este documento?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Formato Carta (Legible)',
          cancelButtonText: 'Formato Ticket (POS)',
          reverseButtons: true,
          focusConfirm: false,
          showDenyButton: false,
          // Colores para que sea claro
          confirmButtonColor: '#0b9257', // Info/Azul (Legible)
          cancelButtonColor: '#2dce89', // Success/Verde (Ticket)
      });

      if (result.isConfirmed) {
          // El usuario seleccionó el botón 'Confirmar' (Legible)
          return 2; // Formato Legible (Carta / DTE Fiscal)
      }
      else if (result.dismiss === this.$swal.DismissReason.cancel) {
          // El usuario seleccionó el botón 'Cancelar' (Ticket)
          return 1; // Formato Ticket (POS)
      }
      // Si el usuario cierra el modal o presiona fuera, devolvemos 0 para cancelar
      return 0;
    },
    valLineLenght() {
      this.currentLineLength=this.productDescription.length+this.currentProductLength;
      if(this.currentLineLength>1000){
        //this.$swal('Límite de caracteres', 'Excede el limite de caracteres válidos permitidos por línea.', 'info');
        this.allowAdd=true;
      }else{
        this.allowAdd=false;
      }
    },
    formatCurrency(value) {
        if (value === null || isNaN(value)) {
            return '0.000';
        }
        // Usamos 'es-ES' o 'en-US' para coma de miles y punto decimal
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
            useGrouping: true // Asegura el separador de miles
        }).format(value);
    },
    formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    },
    getStateClass(state) {
        return state === 'EMITTED' ? 'text-warning' : state === 'PAID' ? 'text-success' : 'text-danger';
    },
    getStateText(state) {
        return state === 'EMITTED' ? 'Emitida' : state === 'PAID' ? 'Pagada' : 'Cancelada';
    },
    goBack() {
        this.$router.push("/invoices");
    },

  },
  mounted(){
    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'Authorization':`Bearer ${token}`
      }
    };
    this.fetchCustomers(config);
    this.fetchProducts(config);
  }
};
</script>

<style scoped>
.card {
  border-radius: 1rem;
}
.table th,
.table td {
  vertical-align: middle;
}
.table input {
  border: none;
  border-bottom: 1px solid #dee2e6;
  border-radius: 0;
}

</style>
